import CN from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { routes } from '../config/routes';
import styles from './FeatureFlagsLink.module.scss';
import { useFeatureFlags } from './useFeatureFlags';
// load css substyles
import './FeatureFlagsLink.module.scss';

export const FeatureFlagsLink = ({ mobile }) => {
  const { t } = useTranslation();
  const { FeatureFlagsUIFlag } = useFeatureFlags();

  if (!FeatureFlagsUIFlag.enabled) {
    return null;
  }
  return (
    <Link
      className={CN({
        [styles.featureFlagsLink]: !mobile,
      })}
      to={routes.featureFlags}
      data-testid="feature-flag-link"
    >
      {mobile && '❇️ '}
      {t('featureFlags.navigation.label')}
    </Link>
  );
};
